/**
 * This helper lazy loads components.
 *
 * @export
 * @param {*} file
 * @returns
 */
export function lazyLoad (file) {
  if (process.env.NODE_ENV === 'production') {
    return () => import(
      /* webpackChunkName: "lazy-" */
      `@/components/${file}.vue`
    )
  }
  return () => import(
    /* webpackChunkName: "lazy-[request]" */
    `@/components/${file}.vue`
  )
}

/**
 * This helper pre-loads components.
 *
 * @export
 * @param {*} file
 * @returns
 */
export function prefetch (file) {
  if (process.env.NODE_ENV === 'production') {
    return () => import(
      /* webpackChunkName: "lazy-" */
      /* webpackPrefetch: true */
      `@/components/${file}.vue`
    )
  }
  return () => import(
    /* webpackChunkName: "lazy-[request]" */
    /* webpackPrefetch: true */
    `@/components/${file}.vue`
  )
}

/**
 * This helper pre-loads components.
 *
 * @export
 * @param {*} file
 * @returns
 */
export function preload (file) {
  if (process.env.NODE_ENV === 'production') {
    return () => import(
      /* webpackChunkName: "lazy-" */
      /* webpackPreload: true */
      `@/components/${file}.vue`
    )
  }
  return () => import(
    /* webpackChunkName: "lazy-[request]" */
    /* webpackPreload: true */
    `@/components/${file}.vue`
  )
}
